/// <amd-module name="Artifacts/Root/helpers/PackageMetricsHelpers" />
import {
  PackageMetrics,
  PackageMetricsQuery,
  PackageVersionMetrics,
  PackageVersionMetricsQuery,
} from "Artifacts/Root/web-apis/contracts/Feed";
import { getFeedClient } from "Artifacts/Root/web-apis/RestClient/Feed";
import { IVssPageContext } from "VSS/Platform/Context";

export function getEmptyMetrics(packageId: string): PackageMetrics {
  return {
    downloadCount: 0,
    downloadUniqueUsers: 0,
    lastDownloaded: new Date(0),
    packageId: packageId,
  } as PackageMetrics;
}

export function getEmptyVersionMetrics(
  packageId: string,
  packageVersionId: string,
): PackageVersionMetrics {
  return {
    downloadCount: 0,
    downloadUniqueUsers: 0,
    lastDownloaded: new Date(0),
    packageId: packageId,
    packageVersionId: packageVersionId,
  } as PackageVersionMetrics;
}

export async function getPackageMetricsAsync(
  pageContext: IVssPageContext,
  feedId: string,
  packageIds: string[],
  projectId?: string,
): Promise<{ [key: string]: PackageMetrics }> {
  const feedRestClient = getFeedClient(pageContext);
  const query: PackageMetricsQuery = { packageIds: packageIds };
  const requestedMetrics = await feedRestClient.queryPackageMetrics(query, feedId, projectId);

  const outMetricsMap: { [key: string]: PackageMetrics } = {};
  // Convert array of metrics into map of package ID => metrics
  packageIds.forEach((packageId: string) => {
    outMetricsMap[packageId] =
      requestedMetrics.find(
        (packageMetric: PackageMetrics) => packageMetric.packageId === packageId,
      ) || getEmptyMetrics(packageId);
  });

  return outMetricsMap;
}

export async function getPackageVersionMetricsAsync(
  pageContext: IVssPageContext,
  feedId: string,
  packageId: string,
  packageVersionIds: string[],
  projectId?: string,
): Promise<{ [key: string]: PackageVersionMetrics }> {
  const feedRestClient = getFeedClient(pageContext);
  const query: PackageVersionMetricsQuery = { packageVersionIds: packageVersionIds };
  const requestedVersionMetrics = await feedRestClient.queryPackageVersionMetrics(
    query,
    feedId,
    packageId,
    projectId,
  );

  const outMetricsMap: { [key: string]: PackageVersionMetrics } = {};
  // Convert array of metrics into map of version ID => metrics
  packageVersionIds.forEach((packageVersionId: string) => {
    outMetricsMap[packageVersionId] =
      requestedVersionMetrics.find(
        (packageVersionMetric: PackageVersionMetrics) =>
          packageVersionMetric.packageVersionId === packageVersionId,
      ) || getEmptyVersionMetrics(packageId, packageVersionId);
  });

  return outMetricsMap;
}
